"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthSuiteAPIVersion = exports.headersService = exports.HeadersService = void 0;
var headers_service_1 = require("./headers.service");
Object.defineProperty(exports, "HeadersService", { enumerable: true, get: function () { return headers_service_1.HeadersService; } });
Object.defineProperty(exports, "headersService", { enumerable: true, get: function () { return headers_service_1.headersService; } });
var models_1 = require("./models");
Object.defineProperty(exports, "AuthSuiteAPIVersion", { enumerable: true, get: function () { return models_1.AuthSuiteAPIVersion; } });
